import { createContext, ReactNode, RefObject, useContext } from 'react';
import {
  useHtmlStepperEditorHook,
  UseHtmlStepperEditorReturn,
} from './hooks/useHtmlStepperEditorHook';

export type {
  EditorDevice,
  EditorMode,
} from './hooks/useHtmlStepperEditorState';

export type HtmlStepperEditorContextType = UseHtmlStepperEditorReturn & {
  onClose: () => void;
  quizId: string;
};

const HtmlStepperEditorContext = createContext<
  HtmlStepperEditorContextType | undefined
>(undefined);

export const useHtmlStepperEditor = () => {
  const context = useContext(HtmlStepperEditorContext);
  if (context === undefined) {
    throw new Error(
      'useHtmlStepperEditor must be used within a HtmlStepperEditorProvider',
    );
  }
  return context;
};

interface HtmlStepperEditorProviderProps {
  quizId: string;
  initialFormId: string;
  children: ReactNode;
  onClose: () => void;
  previewRef: RefObject<HTMLIFrameElement | null>;
}

export const HtmlStepperEditorProvider = ({
  quizId,
  initialFormId,
  children,
  onClose,
  previewRef,
}: HtmlStepperEditorProviderProps) => {
  const editor = useHtmlStepperEditorHook({
    quizId,
    initialFormId,
    previewRef,
  });

  const contextValue: HtmlStepperEditorContextType = {
    ...editor,
    onClose,
    quizId,
  };

  return (
    <HtmlStepperEditorContext.Provider value={contextValue}>
      {children}
    </HtmlStepperEditorContext.Provider>
  );
};
